"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrideoftheEarthArkship = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const ResourceType_1 = require("../../ResourceType");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
const Units_1 = require("../../Units");
const MoonCard_1 = require("./MoonCard");
const CardRequirements_1 = require("../CardRequirements");
class PrideoftheEarthArkship extends MoonCard_1.MoonCard {
    constructor() {
        super({
            name: CardName_1.CardName.PRIDE_OF_THE_EARTH_ARKSHIP,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.SCIENCE, Tags_1.Tags.SPACE],
            cost: 22,
            resourceType: ResourceType_1.ResourceType.SCIENCE,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.tag(Tags_1.Tags.SCIENCE).tag(Tags_1.Tags.SPACE, 2)),
            reserveUnits: Units_1.Units.of({ titanium: 2 }),
            metadata: {
                description: 'Requires 1 science and 2 space tags. Spend 2 titanium. 1 VP per science resource here.',
                cardNumber: 'M24',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Add 1 science resource here per every 5 science tags you have.', (eb) => {
                        eb.empty().startAction.science(1).slash().text('5').science().played;
                    }).br;
                    b.minus().titanium(2);
                }),
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.science(1, 1),
            },
        });
        this.resourceCount = 0;
    }
    ;
    play(player) {
        super.play(player);
        return undefined;
    }
    canAct(player) {
        return player.getTagCount(Tags_1.Tags.SCIENCE) >= 5;
    }
    action(player) {
        const count = Math.floor(player.getTagCount(Tags_1.Tags.SCIENCE) / 5);
        player.addResourceTo(this, count);
        return undefined;
    }
    getVictoryPoints() {
        return this.resourceCount;
    }
}
exports.PrideoftheEarthArkship = PrideoftheEarthArkship;
//# sourceMappingURL=PrideoftheEarthArkship.js.map